import { updateUserInfo } from 'src/api/login';

export function setToken({ commit }, params) {
  commit('updateToken', params);
}

export function setAddressInfo({ commit }, params) {
  commit('updateAddressInfo', params);
}

export function setLoginParams({ commit }, params) {
  commit('updateLoginParams', params);
}

export function setUserInfo({ commit }, params) {
  commit('updateUserInfo', params);
}
export function patchUserInfo({ commit }, params) {
  return new Promise((resolve, reject) => {
    updateUserInfo(params).then(res => {
      if (res.success) {
        commit('updateUserInfo', res.data);
        resolve()
      } else {
        reject('NE');
      }
    }).catch(e => {
      reject('NE');
    })
  })
}
export function setOrderId({ commit }, params) {
  commit('updateOrderId', params);
}

export function setUserId({ commit }, params) {
  commit('updateUserId', params);
}

export function setToLoginPath({ commit }, params) {
  commit('updateToLoginPath', params);
}

export function setLanguage({ commit }, params) {
  commit('updateLanguage', params);
}

export function setScheduled({ commit }, params) {
  commit('updateScheduled', params);
}

export function setScheduledTime({ commit }, params) {
  commit('updateScheduledTime', params);
}

export function setScheduledEndTime({ commit }, params) {
  commit('updateScheduledEndTime', params);
}

export function resetSchedule({ commit }) {
  commit('updateScheduledTime', 0);
  commit('updateScheduledEndTime', 0);
}

export function resetUser({ commit }) {
  commit('updateUserInfo', {});
  commit('updateToken', '');
  localStorage.removeItem('token');
}

export function setCountryCode({ commit }, params) {
  commit('updateCountryCode', params);
}

export function setCountryName({ commit }, params) {
  commit('updateCountryName', params);
}

export function setNearestStatus({ commit }, params) {
  commit('updateNearestStatus', params);
}

export function setFullDineInTableData({ commit }, params) {
  commit('updateFullDineInTableData', params);
}

export function setPlatVoucher({ commit }, params) {
  commit('updatePlatVoucher', params);
}

export function setVoucherDialog({ commit }, params) {
  commit('updateVoucherDialog', params);
}

export function setAccount({ commit }, params) {
  commit('updateAccount', params);
}
